/**
 * Simple logging utility for development and production.
 * - error: always logged (production + dev)
 * - warn, debug: only in development
 */
export const logger = {
  error(message: string, ...args: unknown[]): void {
    console.error(`[ERROR] ${message}`, ...args);
  },

  warn(message: string, ...args: unknown[]): void {
    if (import.meta.env.DEV) {
      console.warn(`[WARN] ${message}`, ...args);
    }
  },

  debug(message: string, ...args: unknown[]): void {
    if (import.meta.env.DEV) {
      console.debug(`[DEBUG] ${message}`, ...args);
    }
  },
};
